import React from 'react';
import QAFeed from '../../components/Analytics/QAFeed';

/**
 * Conversations Page
 *
 * Dedicated page for browsing Q&A conversations with full filtering,
 * split-panel conversation viewer, and CSV export.
 *
 * Previously this was a card on the Analytics Dashboard, but it operates
 * on live conversation data (not pre-aggregated analytics), so it
 * deserves its own top-level page — similar to /explore for documents.
 */
const Conversations: React.FC = () => {
  return (
    <div className="admin-content-container">
      <div className="page-header-row">
        <h2 className="page-title">Conversations</h2>
      </div>
      <QAFeed defaultPeriod="24h" isExpanded={true} />
    </div>
  );
};

export default Conversations;
